import { useEffect, useState } from 'react';
import { getContentWithChildren } from './api/contentDeliveryApi';
import { FrontPage } from './types/optimizely/frontpage';
import { Module } from './components/Module/Module';
import { AppContextProvider } from './context/AppContext';
import { resetPadding } from './lib/resetPadding';

interface AppProps {
	pageId: string;
	language: string;
}

export const JuniorApp = ({ pageId, language }: AppProps) => {
	const [content, setContent] = useState<FrontPage | null>(null);

	useEffect(() => {
		window.addEventListener('load', () => {
			resetPadding();
		});

		window.addEventListener('resize', () => {
			resetPadding();
		});

		getContentWithChildren({ contentId: pageId, lang: language }).then((data) =>
			setContent(data),
		);

		return () => {
			window.removeEventListener('load', () => {
				resetPadding();
			});

			window.removeEventListener('resize', () => {
				resetPadding();
			});
		};
	}, []);

	return (
		<AppContextProvider language={language}>
			<Module content={content} />
		</AppContextProvider>
	);
};
